/**
 * İhbar Süresi ve Tazminatı Hesaplama Engine
 * 4857 sayılı İş Kanunu Madde 17
 */

export const YILI = 2026;
export const BRUT_ASGARI_UCRET = 33_030;

export interface IhbarDilimi {
  minAy: number;
  maxAy: number | null;
  haftaSayisi: number;
  gunSayisi: number;
  label: string;
}

export const IHBAR_DILIMLERI: IhbarDilimi[] = [
  { minAy: 0, maxAy: 6, haftaSayisi: 2, gunSayisi: 14, label: "0 – 6 ay" },
  {
    minAy: 6,
    maxAy: 18,
    haftaSayisi: 4,
    gunSayisi: 28,
    label: "6 ay – 1,5 yıl",
  },
  { minAy: 18, maxAy: 36, haftaSayisi: 6, gunSayisi: 42, label: "1,5 – 3 yıl" },
  {
    minAy: 36,
    maxAy: null,
    haftaSayisi: 8,
    gunSayisi: 56,
    label: "3 yıl üzeri",
  },
];

export interface IhbarGirdi {
  brutMaas: number;
  calismaYili: number;
  calismaAyi: number;
}

export interface IhbarSonuc {
  toplamAy: number;
  dilim: IhbarDilimi;
  gunlukBrutUcret: number;
  ihbarSuresiHafta: number;
  ihbarSuresiGun: number;
  brutIhbarTazminati: number;
  damgaVergisi: number;
  netIhbarTazminati: number;
}

export function formatTL(value: number): string {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function hesaplaIhbar(girdi: IhbarGirdi): IhbarSonuc {
  const brutMaas = Math.max(0, girdi.brutMaas || 0);
  const toplamAy = Math.max(
    0,
    (girdi.calismaYili || 0) * 12 + (girdi.calismaAyi || 0)
  );

  let dilim = IHBAR_DILIMLERI[0];
  for (const d of IHBAR_DILIMLERI) {
    if (d.maxAy === null || toplamAy < d.maxAy) {
      if (toplamAy >= d.minAy) {
        dilim = d;
        break;
      }
    }
    if (toplamAy >= d.minAy && (d.maxAy === null || toplamAy < d.maxAy)) {
      dilim = d;
      break;
    }
  }

  // Kıdeme göre ihbar dilimi belirleme
  if (toplamAy < 6) dilim = IHBAR_DILIMLERI[0];
  else if (toplamAy < 18) dilim = IHBAR_DILIMLERI[1];
  else if (toplamAy < 36) dilim = IHBAR_DILIMLERI[2];
  else dilim = IHBAR_DILIMLERI[3];

  const gunlukBrutUcret = brutMaas / 30;
  const brutIhbarTazminati = gunlukBrutUcret * dilim.gunSayisi;
  const damgaVergisi = brutIhbarTazminati * 0.00759;
  const netIhbarTazminati = brutIhbarTazminati - damgaVergisi;

  return {
    toplamAy,
    dilim,
    gunlukBrutUcret,
    ihbarSuresiHafta: dilim.haftaSayisi,
    ihbarSuresiGun: dilim.gunSayisi,
    brutIhbarTazminati,
    damgaVergisi,
    netIhbarTazminati,
  };
}
